import React from "react";
import { icon as getIcon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { COREIcon, COREIconProps } from "../Content/COREIcon";

export type MenuIconProps = {
  size?: COREIconProps["size"];
  regularIcon: COREIconProps["icon"];
  solidIcon: COREIconProps["icon"];
};
export const MenuIcon: React.FC<MenuIconProps> = ({
  regularIcon,
  solidIcon,
  size,
}) => (
  <>
    <div className={"regular-icon"}>
      <COREIcon icon={regularIcon} size={size} />
    </div>
    <div className={"solid-icon"}>
      <COREIcon icon={solidIcon} size={size} />
    </div>
  </>
);

export const menuIcons = (iconName: string, size?: COREIconProps["size"]) =>
  ({
    home: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "home", style: "regular" })}
        solidIcon={getIcon({ name: "home", style: "solid" })}
      />
    ),
    cog: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "cog", style: "regular" })}
        solidIcon={getIcon({ name: "cog", style: "solid" })}
      />
    ),
    building: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "building", style: "regular" })}
        solidIcon={getIcon({ name: "building", style: "solid" })}
      />
    ),
    "square-list": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "square-list", style: "regular" })}
        solidIcon={getIcon({ name: "square-list", style: "solid" })}
      />
    ),
    receipt: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "receipt", style: "regular" })}
        solidIcon={getIcon({ name: "receipt", style: "solid" })}
      />
    ),
    user: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "user", style: "regular" })}
        solidIcon={getIcon({ name: "user", style: "solid" })}
      />
    ),
    "user-edit": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "user-edit", style: "regular" })}
        solidIcon={getIcon({ name: "user-edit", style: "solid" })}
      />
    ),
    cogs: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "cogs", style: "regular" })}
        solidIcon={getIcon({ name: "cogs", style: "solid" })}
      />
    ),
    "Circle-question": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "circle-question", style: "regular" })}
        solidIcon={getIcon({ name: "circle-question", style: "solid" })}
      />
    ),
    "chart-mixed": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "chart-mixed", style: "regular" })}
        solidIcon={getIcon({ name: "chart-mixed", style: "solid" })}
      />
    ),
    database: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "database", style: "regular" })}
        solidIcon={getIcon({ name: "database", style: "solid" })}
      />
    ),
    "screen-users": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "screen-users", style: "regular" })}
        solidIcon={getIcon({ name: "screen-users", style: "solid" })}
      />
    ),
    code: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "code", style: "regular" })}
        solidIcon={getIcon({ name: "code", style: "solid" })}
      />
    ),
    buildings: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "buildings", style: "regular" })}
        solidIcon={getIcon({ name: "buildings", style: "solid" })}
      />
    ),
    "folder-grid": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "folder-grid", style: "regular" })}
        solidIcon={getIcon({ name: "folder-grid", style: "solid" })}
      />
    ),
    newspaper: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "newspaper", style: "regular" })}
        solidIcon={getIcon({ name: "newspaper", style: "solid" })}
      />
    ),
    books: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "books", style: "regular" })}
        solidIcon={getIcon({ name: "books", style: "solid" })}
      />
    ),
    "box-circle-check": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "box-circle-check", style: "regular" })}
        solidIcon={getIcon({ name: "box-circle-check", style: "solid" })}
      />
    ),
    users: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "users", style: "regular" })}
        solidIcon={getIcon({ name: "users", style: "solid" })}
      />
    ),
    "money-bill-trend-up": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "money-bill-trend-up", style: "regular" })}
        solidIcon={getIcon({ name: "money-bill-trend-up", style: "solid" })}
      />
    ),
    "money-check-dollar-pen": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "money-check-dollar-pen",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "money-check-dollar-pen", style: "solid" })}
      />
    ),
    "cloud-fog": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "cloud-fog", style: "regular" })}
        solidIcon={getIcon({ name: "cloud-fog", style: "solid" })}
      />
    ),
    eye: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "eye", style: "regular" })}
        solidIcon={getIcon({ name: "eye", style: "solid" })}
      />
    ),
    "list-timeline": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "list-timeline", style: "regular" })}
        solidIcon={getIcon({ name: "list-timeline", style: "solid" })}
      />
    ),
    "money-check-dollar": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "money-check-dollar", style: "regular" })}
        solidIcon={getIcon({ name: "money-check-dollar", style: "solid" })}
      />
    ),
    "location-dot": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "location-dot", style: "regular" })}
        solidIcon={getIcon({ name: "location-dot", style: "solid" })}
      />
    ),
    "file-certificate": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "file-certificate", style: "regular" })}
        solidIcon={getIcon({ name: "file-certificate", style: "solid" })}
      />
    ),
    "file-circle-exclamation": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "file-circle-exclamation",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "file-circle-exclamation", style: "solid" })}
      />
    ),
    bolt: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "bolt", style: "regular" })}
        solidIcon={getIcon({ name: "bolt", style: "solid" })}
      />
    ),
    "battery-bolt": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "battery-bolt", style: "regular" })}
        solidIcon={getIcon({ name: "battery-bolt", style: "solid" })}
      />
    ),
    "wind-turbine": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "wind-turbine", style: "regular" })}
        solidIcon={getIcon({ name: "wind-turbine", style: "solid" })}
      />
    ),
    "message-captions": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "message-captions", style: "regular" })}
        solidIcon={getIcon({ name: "message-captions", style: "solid" })}
      />
    ),
    seedling: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "seedling", style: "regular" })}
        solidIcon={getIcon({ name: "seedling", style: "solid" })}
      />
    ),
    certificate: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "certificate", style: "regular" })}
        solidIcon={getIcon({ name: "certificate", style: "solid" })}
      />
    ),
    tag: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "tag", style: "regular" })}
        solidIcon={getIcon({ name: "tag", style: "solid" })}
      />
    ),
    handshake: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "handshake", style: "regular" })}
        solidIcon={getIcon({ name: "handshake", style: "solid" })}
      />
    ),
    "user-group-simple": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "user-group-simple", style: "regular" })}
        solidIcon={getIcon({ name: "user-group-simple", style: "solid" })}
      />
    ),
    "user-tie": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "user-tie", style: "regular" })}
        solidIcon={getIcon({ name: "user-tie", style: "solid" })}
      />
    ),
    "gauge-high": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "gauge-high", style: "regular" })}
        solidIcon={getIcon({ name: "gauge-high", style: "solid" })}
      />
    ),
    "square-poll-vertical": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "square-poll-vertical",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "square-poll-vertical", style: "solid" })}
      />
    ),
    "book-open-reader": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "book-open-reader", style: "regular" })}
        solidIcon={getIcon({ name: "book-open-reader", style: "solid" })}
      />
    ),
    folders: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "folders", style: "regular" })}
        solidIcon={getIcon({ name: "folders", style: "solid" })}
      />
    ),
    "chart-line-up-down": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "chart-line-up-down", style: "regular" })}
        solidIcon={getIcon({ name: "chart-line-up-down", style: "solid" })}
      />
    ),
    "code-fork": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "code-fork", style: "regular" })}
        solidIcon={getIcon({ name: "code-fork", style: "solid" })}
      />
    ),
    "file-lines": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "file-lines", style: "regular" })}
        solidIcon={getIcon({ name: "file-lines", style: "solid" })}
      />
    ),
    megaphone: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "megaphone", style: "regular" })}
        solidIcon={getIcon({ name: "megaphone", style: "solid" })}
      />
    ),
    "chart-mixed-up-circle-dollar": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "chart-mixed-up-circle-dollar",
          style: "regular",
        })}
        solidIcon={getIcon({
          name: "chart-mixed-up-circle-dollar",
          style: "solid",
        })}
      />
    ),
    "earth-oceania": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "earth-oceania", style: "regular" })}
        solidIcon={getIcon({ name: "earth-oceania", style: "solid" })}
      />
    ),
    "chart-line": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "chart-line", style: "regular" })}
        solidIcon={getIcon({ name: "chart-line", style: "solid" })}
      />
    ),
    "cart-flatbed": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "cart-flatbed", style: "regular" })}
        solidIcon={getIcon({ name: "cart-flatbed", style: "solid" })}
      />
    ),
    tools: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "tools", style: "regular" })}
        solidIcon={getIcon({ name: "tools", style: "solid" })}
      />
    ),
    "message-exclamation": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "message-exclamation", style: "regular" })}
        solidIcon={getIcon({ name: "message-exclamation", style: "solid" })}
      />
    ),
    globe: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "globe", style: "regular" })}
        solidIcon={getIcon({ name: "globe", style: "solid" })}
      />
    ),
    "map-location": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "map-location", style: "regular" })}
        solidIcon={getIcon({ name: "map-location", style: "solid" })}
      />
    ),
    "map-location-dot": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "map-location-dot", style: "regular" })}
        solidIcon={getIcon({ name: "map-location-dot", style: "solid" })}
      />
    ),
    "circle-plus": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "circle-plus", style: "regular" })}
        solidIcon={getIcon({ name: "circle-plus", style: "solid" })}
      />
    ),
    createDashboard: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "circle-plus", style: "regular" })}
        solidIcon={getIcon({ name: "circle-plus", style: "solid" })}
      />
    ),
    lock: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "lock", style: "regular" })}
        solidIcon={getIcon({ name: "lock", style: "solid" })}
      />
    ),
    locked: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "lock", style: "regular" })}
        solidIcon={getIcon({ name: "lock", style: "solid" })}
      />
    ),
    toolbox: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "toolbox", style: "regular" })}
        solidIcon={getIcon({ name: "toolbox", style: "solid" })}
      />
    ),
    list: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "list", style: "regular" })}
        solidIcon={getIcon({ name: "list", style: "solid" })}
      />
    ),
    "magnifying-glass-chart": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "magnifying-glass-chart",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "magnifying-glass-chart", style: "solid" })}
      />
    ),
    "chart-bullet": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "chart-bullet",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "chart-bullet", style: "solid" })}
      />
    ),
    gauge: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "gauge",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "gauge", style: "solid" })}
      />
    ),
    "calendar-lines-pen": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "calendar-lines-pen",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "calendar-lines-pen", style: "solid" })}
      />
    ),
    "plug-circle-bolt": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "plug-circle-bolt",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "plug-circle-bolt", style: "solid" })}
      />
    ),
    sparkles: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "sparkles",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "sparkles", style: "solid" })}
      />
    ),
    "folder-tree": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "folder-tree",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "folder-tree", style: "solid" })}
      />
    ),
    "file-chart-column": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "file-chart-column",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "file-chart-column", style: "solid" })}
      />
    ),
    "cart-flatbed-boxes": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "cart-flatbed-boxes",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "cart-flatbed-boxes", style: "solid" })}
      />
    ),
    "arrow-left-arrow-right": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "arrows-left-right",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "arrows-left-right", style: "solid" })}
      />
    ),
    "clipboard-list": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "clipboard-list",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "clipboard-list", style: "solid" })}
      />
    ),
    gear: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "gear",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "gear", style: "solid" })}
      />
    ),
    "file-contract": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "file-contract",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "file-contract", style: "solid" })}
      />
    ),
    rotate: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "rotate",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "rotate", style: "solid" })}
      />
    ),
    "chart-gantt": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "chart-gantt",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "chart-gantt", style: "solid" })}
      />
    ),
    "table-cells": (
      <MenuIcon
        size={size}
        regularIcon={getIcon({
          name: "table-cells",
          style: "regular",
        })}
        solidIcon={getIcon({ name: "table-cells", style: "solid" })}
      />
    ),
    book: (
      <MenuIcon
        size={size}
        regularIcon={getIcon({ name: "book", style: "regular" })}
        solidIcon={getIcon({ name: "book", style: "solid" })}
      />
    ),
  }[iconName]);
